<template>
    <div class="drawer" id="drawer">
        <main-menu></main-menu>
    </div>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue'

import MainMenu from './MainMenu.vue'

export default defineComponent({
    components: {
        MainMenu
    },
    setup() {

        // const { headerData } = useHeaderStore()
        // const main = useMainStore()

        // const main = useHeaderStore()

        // console.log('sea',main)

        // if (!headerData) {
        // const query = ref(HEADER_QUERY)
        // const { result } = useQuery(query)
        //
        //     result.then(({ data }) => {
        //         setHeaderData(data.header)
        //     })
        // }

        return {
            // headerData,
            // result,
            // fronturl,
            // main,
            // homeurl?
        }
    }
})

</script>
